import React, {useEffect, useRef, useState} from "react";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import InputField from "../../components/InputField";
import {IconButton} from "@mui/material";
import {UpdateOutlined} from "@mui/icons-material";
import {reportErrors} from "../../helpers";
import {BASE_URL} from "../../constants";
import AlertBar from "../../components/AlertBar";

export default function ReviewConfiguration(props) {
    const alert = useRef();
    const [googleUrl, setGoogleUrl] = useState();
    const [tripadvisor, setTripadvisor] = useState();

    useEffect(() => {
        loadData();
    }, []);

    const loadData = () => {
        let url = `${BASE_URL}api/settings/review-configuration`;
        window.axios
            .get(url)
            .then((response) => {
                setGoogleUrl(response.data.data?.google_url);
                setTripadvisor(response.data.data?.tripadvisor_url);
            })
            .catch((error) => {
                reportErrors(alert.current, error);
            });
    };

    const submit = () => {
        let data = {
            google_url: googleUrl,
            tripadvisor_url: tripadvisor
        }
        alert.current.showProgress();
        window.axios
            .post(`${BASE_URL}api/settings/review-configuration`, data)
            .then(response => {
                alert.current.showSuccess("Update Successfully.");
            })
            .catch(error => {
                reportErrors(alert.current, error);
            });
    }

    return (
        <>
            <AlertBar ref={alert}/>
            <TableContainer component={Paper}>
                <Table sx={{minWidth: 650}} size="small" aria-label="a dense table">
                    <TableBody>
                        <TableRow
                            key={1}
                            sx={{'&:last-child td, &:last-child th': {border: 0}}}
                        >
                            <TableCell component="th" scope="row">Google Review</TableCell>
                            <TableCell>
                                <InputField
                                    defaultValue={googleUrl}
                                    type="text"
                                    onChange={(value) => setGoogleUrl(value)}
                                />
                            </TableCell>
                            <TableCell align="right">
                                <IconButton size="small" onClick={() => submit()}><UpdateOutlined/></IconButton>
                            </TableCell>
                        </TableRow>
                        <TableRow
                            key={2}
                            sx={{'&:last-child td, &:last-child th': {border: 0}}}
                        >
                            <TableCell component="th" scope="row">Tripadvisor</TableCell>
                            <TableCell>
                                <InputField
                                    defaultValue={tripadvisor}
                                    type="text"
                                    onChange={(value) => setTripadvisor(value)}
                                />
                            </TableCell>
                            <TableCell align="right">
                                <IconButton size="small" onClick={() => submit()}><UpdateOutlined/></IconButton>
                            </TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </TableContainer>
        </>
    );
}